import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import getExperienceItemsView from 'checkout/selectors/view/itemViews/getExperienceItemsView'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/getPromoKeyForLoyaltyItem'
import { generateLoyaltyPointsCalculatorExperienceOptions } from 'loyalty/lib/pointsCalculation/calculatorOptionsGenerators'

const getCheckoutExperiencePointsCalculationRequests = createSelector(
  (state: App.State) => getExperienceItemsView(state),
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (experienceViews, promoLoyaltyBonusResultV1): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!experienceViews.hasRequiredData) return EmptyArray

    return experienceViews.data.flatMap((itemView) => itemView.ticketViews.map((ticketView): App.LoyaltyPointsEarnCalculationRequest => {
      const itemId = ticketView.item.itemId
      const request = generateLoyaltyPointsCalculatorExperienceOptions(itemView.experience, {
        offerId: itemView.experienceId,
        price: ticketView.totals.price,
        memberPrice: ticketView.totals.memberPrice,
        promoKey: getPromoKeyForLoyaltyItem(promoLoyaltyBonusResultV1, { filter: { itemId } }),
      })!

      const checkoutRequest = {
        ...request,
        // Local checkout correlation only; omitted from the API payload and points key.
        itemId,
      }

      return checkoutRequest
    }))
  },
)

export default getCheckoutExperiencePointsCalculationRequests
